/**
 * OpsMate 共享布局
 * 将 PortalLayout 与 OpsMateProvider 提升到路由父层，
 * 使 /opsmate、/general-source、/personal-source、/study-source 之间切换时 Provider 不重新挂载，
 * 从而左侧会话菜单状态得以保留、不被刷新。
 */
import { Outlet } from "react-router-dom";

import PortalLayout from "@/components/layout/PortalLayout";
import { OpsMateProvider } from "@/contexts/OpsMateContext";

export default function OpsMateLayout() {
  return (
    <PortalLayout>
      <OpsMateProvider>
        <Outlet />
      </OpsMateProvider>
    </PortalLayout>
  );
}
